import { IVR_URLS } from "../../services/apiConfig.js";
import { JOB_ERRORS } from "../../common/constants/ivrModule/jobConstants.js";
import apiClient from "../apiInstance.js";

export const getIvrJob = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.GET_IVR_JOB);
        const jobs = response.data.policy?.value || [];

        const responseJobs = jobs.map((job) => {
            const assignment = Object.values(job.assignments || {})[0] || {};

            return {
                id: job.id,
                status: job.status,
                enqueuedAt: job.enqueuedAt,
                queueId: job.queueId,
                priority: job.priority,
                channelId: job.channelId,
                skill: job.requestedWorkerSelectors?.[0]?.key || "",
                operator:
                    job.requestedWorkerSelectors?.[0]?.labelOperator || "",
                skillValue: job.requestedWorkerSelectors?.[0]?.value || "",
                workerId: assignment.workerId || "",
                assignedAt: assignment.assignedAt || "",
                etag: job.etag,
            };
        });

        return responseJobs;
    } catch (error) {
        console.error(JOB_ERRORS.FETCH_JOB_ERROR, error);
        throw error;
    }
};

export const addIvrJob = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.ADD_IVR_JOB);
        return response.data;
    } catch (error) {
        console.error(JOB_ERRORS.ADD_JOB_ERROR, error);
        throw error;
    }
};

export const deleteIvrJob = async (jobId) => {
    try {
        const response = await apiClient.post(IVR_URLS.DELETE_IVR_JOB, {
            jobId,
        });
        return response.data;
    } catch (error) {
        console.error(JOB_ERRORS.DELETE_JOB_ERROR, error);
        throw error;
    }
};

export const cancelIvrJob = async (jobId) => {
    try {
        const response = await apiClient.post(IVR_URLS.CANCEL_IVR_JOB, {
            jobId,
        });
        return response.data;
    } catch (error) {
        console.error(JOB_ERRORS.CANCEL_JOB_ERROR, error);
        throw error;
    }
};

export const acceptIvrJob = async ({
    workerId,
    offerId,
    channelReference,
    customerAcsId,
    agentAcsId,
}) => {
    try {
        const response = await apiClient.post(IVR_URLS.ACCEPT_IVR_JOB_OFFER, {
            workerId,
            offerId,
            channelReference,
            customerAcsId,
            agentAcsId,
        });
        console.log("front end api data", response);
        return response.data;
    } catch (error) {
        console.error(JOB_ERRORS.ACCEPT_JOB_ERROR, error);
        throw error;
    }
};

export const editIvrJob = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.ACCEPT_IVR_JOB_OFFER);
        return response.data;
    } catch (error) {
        console.error(JOB_ERRORS.ACCEPT_JOB_ERROR, error);
        throw error;
    }
};

export const getJobOffers = async (workerId) => {
    try {
        const response = await apiClient.post(IVR_URLS.CALL_JOB_POLLING, {
            workerId,
        });

        const offer = response.data?.offer;
        //const customerAcsId = offer?.labels?.customerAcsId;

        if (!offer) {
            //console.warn("⚠️ No offer object found in response.");
            return null;
        }
        //console.log("Offer.", offer);
        return {
            offerId: offer.offerId,
            jobId: offer.jobId,
            expiresAt: offer.expiresAt,
            capacityCost: offer.capacityCost,
            workerId: offer.workerId,
            channelReference: offer.channelReference,
            customerAcsId: offer.customerAcsId,
            customerguid: offer.customerguid,
        };
    } catch (error) {
      //console.warn("No offers available.");
      console.error(error);
      return null;
    }
};

export const getChatJobOffers = async (workerId) => {
    try {
      const response = await apiClient.post(IVR_URLS.CHAT_JOB_POLLING, {
        workerId
      });
  
      const offer = response.data?.offer;
      //const customerAcsId = offer?.labels?.customerAcsId;
  
      if (!offer) {
        //console.warn("⚠️ No offer object found in response.");
        return null;
      }
      //console.log("Offer.", offer);
      return {
        offerId: offer.offerId,
        jobId: offer.jobId,
        expiresAt: offer.expiresAt,
        capacityCost: offer.capacityCost,
        workerId: offer.workerId,
        channelReference: offer.channelReference,
        customerAcsId: offer.customerAcsId,
        customerguid: offer.customerguid,
        userToken: offer.userToken,
      };
    } catch (error) {
      //console.warn("No chat offers available.");
      console.error(error);
      return null;
    }
};

export const completeIvrAssignment = async () => {
    try {
        const response = await apiClient.post(IVR_URLS.ADD_IVR_JOB);
        return response.data;
    } catch (error) {
        console.error(JOB_ERRORS.ADD_JOB_ERROR, error);
        throw error;
    }
}; 

export const removeChatbot = async ({ threadId}) => {
  try {
    const response = await apiClient.post(IVR_URLS.REMOVE_CHAT_BOT, {
      threadId
    });
    console.log("remove cara bot", response)
    return response.data;
  } catch (error) {
    console.error(JOB_ERRORS.ACCEPT_JOB_ERROR, error);
    throw error;
  }
};


  
  
  
  